enum Specification {
    ASYNCAPI = 'asyncapi',
    OPENAPI = 'openapi',
    SWAGGER = 'swagger',
    NONE = ''
}

export default Specification;
